/**
 * API文档地址
 * http://yapi.kapeixi.cn/project/814/interface/api/cat_9817
 */

import { message } from 'ant-design-vue'
import {
  commodity_baseInfo_get,
  commodity_deduct_get,
  commodity_detail_get,
  commodity_detail_banner_post,
  commodity_hot_media_get,
  commodity_link_get,
  commodity_model_info_get,
  commodity_model_info_post,
  commodity_model_infos_post,
  commodity_point_get,
  commodity_point_post,
  commodity_postCache_post,
  commodity_priceInventory_post,
  commodity_queryActivityCountdown_post,
  commodity_queryAmbienceDesc_get,
  commodity_queryPriceChange_post,
  commodity_recommend_get,
  commodity_recommend_post,
  commodity_recommend_deprecated_post,
  commodity_selfbuild_detail_get,
  commodity_selfbuild_split_info_post,
  commodity_setCache_get,
  commodity_shippingReturn_get,
  commodity_shippingReturn_post,
  commodity_split_info_get,
  commodity_split_info_post,
  commodity_split_info_deprecated_post,
  commodity_split_page_get,
  commodity_spu_info_post,
  commodity_test_priceInventory_post,
  commodity_trans2SkcCode_post,
  commodity_selfbuild_batch_detail_get
} from 'server/modules/9817'

// getBaseInfo
export const commodity_baseInfo_get_ = async function(params) {
  const { success, data, retInfo } = await commodity_baseInfo_get(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 查询积分抵扣商品
export const commodity_deduct_get_ = async function(params) {
  const { success, data, retInfo } = await commodity_deduct_get(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// queryCommodityDetail
export const commodity_detail_get_ = async function(params) {
  const { success, data, retInfo } = await commodity_detail_get(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// queryPdpBanner
export const commodity_detail_banner_post_ = async function(params) {
  const { success, data, retInfo } = await commodity_detail_banner_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 红人视频
export const commodity_hot_media_get_ = async function(params) {
  const { success, data, retInfo } = await commodity_hot_media_get(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 大码联动
export const commodity_link_get_ = async function(params) {
  const { success, data, retInfo } = await commodity_link_get(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 查询模特信息
export const commodity_model_info_get_ = async function(params) {
  const { success, data, retInfo } = await commodity_model_info_get(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 查询模特信息
export const commodity_model_info_post_ = async function(params) {
  const { success, data, retInfo } = await commodity_model_info_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 查询模特信息
export const commodity_model_infos_post_ = async function(params) {
  const { success, data, retInfo } = await commodity_model_infos_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// calPonitsGet
export const commodity_point_get_ = async function(params) {
  const { success, data, retInfo } = await commodity_point_get(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// calPonits
export const commodity_point_post_ = async function(params) {
  const { success, data, retInfo } = await commodity_point_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 设置缓存
export const commodity_postCache_post_ = async function(params) {
  const { success, data, retInfo } = await commodity_postCache_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 实时查价格库存
export const commodity_priceInventory_post_ = async function(params) {
  const { success, data, retInfo } = await commodity_priceInventory_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// pdp倒计时
export const commodity_queryActivityCountdown_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await commodity_queryActivityCountdown_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 查询skc氛围文案
export const commodity_queryAmbienceDesc_get_ = async function(params) {
  const { success, data, retInfo } = await commodity_queryAmbienceDesc_get(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 秒杀倒计时
export const commodity_queryPriceChange_post_ = async function(params) {
  const { success, data, retInfo } = await commodity_queryPriceChange_post(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// pdp推荐商品
export const commodity_recommend_get_ = async function(params) {
  const { success, data, retInfo } = await commodity_recommend_get(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// pdp推荐商品
export const commodity_recommend_post_ = async function(params) {
  const { success, data, retInfo } = await commodity_recommend_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// pdp推荐商品
export const commodity_recommend_deprecated_post_ = async function(params) {
  const { success, data, retInfo } = await commodity_recommend_deprecated_post(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// querySelfBuildCommodityDetail
export const commodity_selfbuild_detail_get_ = async function(params) {
  const { success, data, retInfo } = await commodity_selfbuild_detail_get(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 自建站-分体详情
export const commodity_selfbuild_split_info_post_ = async function(params) {
  const { success, data, retInfo } = await commodity_selfbuild_split_info_post(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 设置缓存
export const commodity_setCache_get_ = async function(params) {
  const { success, data, retInfo } = await commodity_setCache_get(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// shipping&return
export const commodity_shippingReturn_get_ = async function(params) {
  const { success, data, retInfo } = await commodity_shippingReturn_get(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// shipping&return
export const commodity_shippingReturn_post_ = async function(params) {
  const { success, data, retInfo } = await commodity_shippingReturn_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 分体详情Get接口
export const commodity_split_info_get_ = async function(params) {
  const { success, data, retInfo } = await commodity_split_info_get(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 分体详情
export const commodity_split_info_post_ = async function(params) {
  const { success, data, retInfo } = await commodity_split_info_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 分体详情
export const commodity_split_info_deprecated_post_ = async function(params) {
  const { success, data, retInfo } = await commodity_split_info_deprecated_post(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// buy it with(B方案)
export const commodity_split_page_get_ = async function(params) {
  const { success, data, retInfo } = await commodity_split_page_get(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// getSpuInfo
export const commodity_spu_info_post_ = async function(params) {
  const { success, data, retInfo } = await commodity_spu_info_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 实时查价格库存
export const commodity_test_priceInventory_post_ = async function(params) {
  const { success, data, retInfo } = await commodity_test_priceInventory_post(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// trans2SkcCode
export const commodity_trans2SkcCode_post_ = async function(params) {
  const { success, data, retInfo } = await commodity_trans2SkcCode_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// queryBacthSkcDetails
export const commodity_selfbuild_batch_detail_get_ = async function(params) {
  const { success, data, retInfo } = await commodity_selfbuild_batch_detail_get(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}
